// Angular
import '../node_modules/angular';
import '../node_modules/angular-animate/angular-animate.min.js';
import '../node_modules/angular-sanitize/angular-sanitize.min.js';
import '../node_modules/angular-cookies/angular-cookies.min.js';

// lodash
import '../node_modules/lodash/lodash.js';

// Other node_modulesraries
import '../node_modules/angular-ui-router/release/angular-ui-router.min.js';
import '../node_modules/moment/moment.js';
import '../node_modules/angular-moment/angular-moment.min.js';
import '../node_modules/moment-duration-format/lib/moment-duration-format.js';
import '../node_modules/angular-ui-bootstrap/dist/ui-bootstrap-tpls.js';
import '../node_modules/ng-file-upload/dist/ng-file-upload.min.js';
import '../node_modules/angular-elastic/elastic.js';
import '../node_modules/angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.min.js';
import '../node_modules/ui-select/dist/select.min.js';
import '../node_modules/ng-mask/dist/ngMask.min.js';
import '../node_modules/ng-password-strength/dist/scripts/ng-password-strength.min.js';
import '../node_modules/angular-loading-bar/build/loading-bar.min.js';
import '../node_modules/satellizer/satellizer.min.js';
import '../node_modules/angular-utils-pagination/dirPagination.js';
import '../node_modules/angular-scroll/angular-scroll.min.js';
import './modified-libraries/angular-ui-router-title.js';
import '../node_modules/angulartics/dist/angulartics.min.js';
import '../node_modules/angulartics-google-analytics/dist/angulartics-ga.min.js';
import '../node_modules/angular-fcsa-number/src/fcsaNumber.min.js';
import '../node_modules/ngmap/build/scripts/ng-map.min.js';
import '../node_modules/angular-click-outside/angular-click-outside.js';
import '../node_modules/angular-fontawesome/dist/angular-fontawesome.min.js';
import '../node_modules/croppie/croppie.min.js';
import '../node_modules/angular-waypoints/dist/angular-waypoints.min.js';
import '../node_modules/ckeditor/ckeditor.js';
import '../node_modules/ng-ckeditor/dist/ng-ckeditor.js';



// WEBPACK FOOTER //
// ./vendors.js